<template>
    <data-table
        :action-button-text="system.license.features.branch ? 'شعبه جدید' : ''"
        action-button-icon="add"
        show-select
        :remove-key="system.license.features.branch ? 'branch' : false"
        export-key="branches"
        settings-key="branches"
        @click:actionButton="router.push({path: '/branches/new' })"
        @getList="getList"
        @deleted="system.setSystemDefaults(true); auth.fetchUser(true);"
        :rowClick="(row) => router.resolve({path: `/branches/${row.id}`})"
        :headers="headers"
        :items="items"
        :loading="loading"
        :totalItems="totalItems"
        :filters="filters"
        :getAllList="getAllList"
    >
        <template #item.tickets_0="{value}">
            <v-chip color="error" variant="flat" class="px-5 rounded text-small">{{value}}</v-chip>
        </template>
        <template #item.tickets_1="{value}">
            <v-chip color="grey-darken-2" variant="flat" class="px-5 rounded text-small">{{value}}</v-chip>
        </template>
        <template #item.tickets_2="{value}">
            <v-chip color="secondary" variant="flat" class="px-5 rounded text-small">{{value}}</v-chip>
        </template>
        <template #item.tickets_3="{value}">
            <v-chip color="warning" variant="flat" class="px-5 rounded text-small">{{value}}</v-chip>
        </template>
        <template #item.tickets_4="{value}">
            <v-chip color="success" variant="flat" class="px-5 rounded text-small">{{value}}</v-chip>
        </template>
    </data-table>
</template>
<script setup>
import { useApi } from '@/plugins/api';
import { useAuthStore } from '@/stores/auth';
import { useSystemStore } from '@/stores/system';
import { useRouter } from 'vue-router';

defineOptions({
    title: "شعبه‌ها",
    validate(context) {
        return context.auth.user.full_admin;
    },
})
const api = useApi();
const router = useRouter();
const system = useSystemStore();
const auth = useAuthStore();
const loading = ref(false);
const items = ref([]);
const totalItems = ref(0);
const headers = ref([
    {
        title: 'عنوان',
        key: 'name',
        value: (item) => item.name,
        minWidth: 220,
    },
    {
        title: 'آمار تیکت ها',
        key: 'tickets',
        align: 'center',
        children: [
            {
                title: 'باز',
                key: 'tickets_0',
                minWidth: 85,
                align: 'center',
                value: (item) => item.tickets[0] ?? '0'
            },
            {
                title: 'پاسخ کارشناس',
                key: 'tickets_2',
                minWidth: 85,
                align: 'center',
                value: (item) => item.tickets[2] ?? '0'
            },
            {
                title: 'در حال انجام',
                key: 'tickets_1',
                minWidth: 85,
                align: 'center',
                value: (item) => item.tickets[1] ?? '0'
            },
            {
                title: 'پاسخ مشتری',
                key: 'tickets_3',
                minWidth: 85,
                align: 'center',
                value: (item) => item.tickets[3] ?? '0'
            },
            {
                title: 'بسته شده',
                key: 'tickets_4',
                minWidth: 85,
                align: 'center',
                value: (item) => item.tickets[4] ?? '0'
            },
        ],
        filterable: false,
        sortable: false,
    },
    {
        title: 'شماره تماس',
        key: 'landline',
        value: (item) => item.landline,
        minWidth: 200,
    },
    {
        title: 'تعداد تیکت',
        key: 'tickets_count',
        value: (item) => item.tickets_count,
        minWidth: 120,
    },
    {
        title: 'تعداد مشتریان',
        key: 'customers_count',
        value: (item) => item.customers_count,
        minWidth: 120,
    },
    {
        title: 'تعداد کاربران سازمانی',
        key: 'employees_count',
        value: (item) => item.employees_count,
        minWidth: 120,
    },
    {
        title: 'میانگین رضایتمندی',
        key: 'satisfaction',
        value: (item) => item.satisfaction ? Math.ceil(item.satisfaction) + '%' : undefined,
        minWidth: 180,
        permission: system.license.features.satisfaction_reply,
    },
    {
        title: 'وضعیت',
        key: 'status',
        value: (item) => item.status ? 'فعال' : 'غیر فعال',
        minWidth: 70,
    },
]);
const filters = ref({
    page: { type: 'hidden', label: 'صفحه', value: 1 },
    perPage: { type: 'hidden', label: 'تعداد آیتم در صفحه', value: 10 },
    keyword_based: { type: 'divider', label: 'بر اساس عنوان', value: null },
    s: { type: 'text', label: 'عنوان', value: null },
    status_based: { type: 'divider', label: 'بر اساس وضعیت', value: null },
    status: { type: 'autocomplete', label: 'وضعیت', items: [{ name: 'فعال', id: '1' },{ name: 'غیرفعال', id: '0' }], value: null },
})
async function getList(finalFilters, cb = false) {
    loading.value = true;
    await api.branchList(finalFilters).then(async res => {
        if (res && res.status == "OK") {
            items.value = res.data;
            totalItems.value = res.total;
        }
    }).finally(() => loading.value = false);
    if (cb)
        cb();
}
async function getAllList(finalFilters) {
    let page = 1, data = [];
    while (page) {
        await api.branchList({
            ...finalFilters,
            perPage: 200,
            page: page,
        }).then(async res => {
            if (res && res.status == "OK") {
                data = data.concat(res.data);
                page = page == res.totalPages ? false : page + 1
            } else
                page = false;
        }).catch(() => page = false);
    }
    return data;
}
</script>
